import { Archive, FileText, ArrowRight } from "react-feather";
import { CardBody, Col, Row } from "reactstrap";
import { H4, LI, UL } from "../../../AbstractElements";
import { Href } from "../../../Constant";
import { KNOWLEDGEBASE_DATA } from "../../../Data/Knowledgebase";
import { Link } from "react-router-dom";

export const CategoryDataCardBody = () => {
  return (
    <CardBody>
      <Row className="browse g-sm-4 g-3">
        {KNOWLEDGEBASE_DATA.map((data) => (
          <Col xl="4" md="6" key={data.id} className="xl-50">
            <div className="browse-articles">
              <H4><span><Archive /></span>{data.title}</H4>
              <UL className="simple-list">
                {data.knowledgeList &&
                  data.knowledgeList.map((data, index2) => (
                    <LI key={index2} className="border-0">
                      <Link to={Href}>
                        {data.fileTextIcon ? (<span><FileText /></span>) : (<span><ArrowRight /></span>)}
                        <span>{data.text}</span>
                        {data.badge ? <span className="badge badge-primary pull-right">{data.badge}</span> : " "}
                      </Link>
                    </LI>
                  ))}
              </UL>
            </div>
          </Col>
        ))}
      </Row>
    </CardBody>
  );
};
